export const trialName = "ORBITA-2";



//////////////////
// WEBPACK FOOTER
// ./src/components/trialConfig.mjs
// module id = 491
// module chunks = 1